type HolderConfigApi = { enabled: boolean; skippable: boolean };

class HolderConfiguration {
  private readonly enabled: boolean;
  private readonly skippable: boolean;

  constructor(holderConfig: HolderConfigApi) {
    this.enabled = holderConfig.enabled;
    this.skippable = holderConfig.skippable;
  }

  isEnabled() {
    return this.enabled;
  }

  isSkippable() {
    return this.skippable;
  }
}

export type { HolderConfigApi };
export { HolderConfiguration };
